import React from "react";
import moment from "moment";
import Text from "../../common/typography/text.js";
import { Skeleton } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import "./AssociatedActivity.css";

const formatActivityDate = (date) => {
  const parsed = moment(date);
  return parsed.isValid() ? parsed.format("MM-DD-YYYY HH:mm") : date;
};

/**
 * Associated Activity — the right-hand timeline on the User details page.
 * Presentational; data is fetched by the parent via userService.getUserActivity.
 * Each item: { message, date, byUser }.
 */
const AssociatedActivity = ({
  activity,
  loading,
  nextCursor,
  onLoadMore,
  error,
  onRefresh,
}) => {
  return (
    <div className="associated-activity">
      <div className="associated-activity-header">
        <Text variant="bodyText" color="darkText">
          Associated Activity
        </Text>
        {onRefresh && (
          <button
            type="button"
            className="associated-activity-refresh"
            aria-label="Refresh activity"
            title="Refresh activity"
            disabled={loading}
            onClick={onRefresh}
          >
            <ReloadOutlined spin={loading} />
          </button>
        )}
      </div>
      <div className="associated-activity-list">
        {loading ? (
          <Skeleton active paragraph={{ rows: 6 }} title={false} />
        ) : activity && activity.length > 0 ? (
          activity.map((item, idx) => (
            <div className="associated-activity-item" key={item.id ?? idx}>
              <Text variant="smallText" color="darkText">
                {item.message}
              </Text>
              <div className="associated-activity-meta">
                <Text variant="tinyText" color="lightText">
                  {formatActivityDate(item.date)}
                </Text>
                <Text variant="tinyText" color="lightText">
                  {item.byUser}
                </Text>
              </div>
            </div>
          ))
        ) : (
          <Text variant="tinyText" color="lightText">
            No activity yet.
          </Text>
        )}
      </div>
      {error && (
        <Text variant="tinyText">Unable to load activity. Please retry.</Text>
      )}
      {nextCursor && (
        <button type="button" disabled={loading} onClick={onLoadMore}>
          Load older activity
        </button>
      )}
    </div>
  );
};

export default AssociatedActivity;
